export function Logo() {
  return (
    <div className="logo" aria-label="Gestor de Mídia">
      <span className="logo-mark">
        <i />
        <i />
        <i />
      </span>
      <span>
        GESTOR<small>DE MÍDIA</small>
      </span>
    </div>
  );
}
